import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

import { SafeHtmlPipe } from '@digital-platform/rs-shared/ui';
import { IconComponent } from '@digital-platform/rs-shared/ui-brand';

/**
 * A component that displays an alert message for Form related errors.
 */
@Component({
  selector: 'digital-platform-form-alert',
  standalone: true,
  imports: [CommonModule, IconComponent, SafeHtmlPipe],
  templateUrl: './form-alert.component.html',
  styleUrls: ['./form-alert.component.scss'],
})
export class FormAlertComponent {
  @Input() show = false;
  @Input() errorContent = '';
}
